import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import asyncRoute from '../../helpers/hoc/asyncRoute';
import routes from '../../routes';

const OfferList = asyncRoute(() => import('./OfferList'));
const AvailOffer = asyncRoute(() => import('./AvailOffer'));

export default class Offer extends React.Component {
  render() {
    const { match } = this.props;
    return (
      <Switch>
        <Route
          exact
          path={`${match.path}`}
          render={() => <Redirect to={`${match.path}/${routes.offers.offerList}`} />}
        />
        <Route exact path={`${match.path}/${routes.offers.offerList}`} component={OfferList} />
        <Route
          exact
          path={`${match.path}/${routes.offers.availOffer}/:offerId`}
          component={AvailOffer}
        />
      </Switch>
    );
  }
}
